import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {ApiService} from "../../core/api/api.service";

@Component({
    selector: 'bergh-extra-cost-tab',
    templateUrl: './extra-cost-tab.component.html',
    styleUrls: ['./extra-cost-tab.component.scss'],
    standalone: false
})

export class ExtraCostTabComponent implements OnInit, OnChanges {
  public addCostForm: UntypedFormGroup;
  extraCosts:any[] = [];
  @Input() saveExtraCostEvent: boolean;
  projectId: string;
  loading: boolean = false;
  @Output() saveExtraCostEventStatus: EventEmitter<boolean> = new EventEmitter()

  constructor(
    private formFB: UntypedFormBuilder,
    private _api: ApiService,
    private _toastr: ToastrService,
    private _route: ActivatedRoute,
    private _elemRef: ElementRef) {
    this.loadAddCostForm()
    }

  ngOnInit(): void {
    this.projectId = this._route.snapshot.paramMap.get('id');
    this.getExistingExtraCosts();
  }

  ngOnChanges(): void{
    if(this.saveExtraCostEvent){
      this.saveExtraCosts()
    }
  }

  loadAddCostForm(){
    this.addCostForm = this.formFB.group({
      data: this.formFB.array([])
    })
  }

  getExistingExtraCosts(){
    this.data.clear();
    this.loading = true;
    this._api.request('getProjectCostDetails', '',`${this.projectId}/cost-management/`).subscribe((result) => {
      this.extraCosts = result.otherCosts;
      for (let i = 0; i < this.extraCosts.length; i++) {
        let filteredCosts:any[] =[];
        filteredCosts = this.extraCosts.filter((item) => item.activeState.indexOf('active') !== -1)
        this.extraCosts = [];
        this.extraCosts = filteredCosts;
        let { _id, name, noOfUnits, pricePerUnit } = this.extraCosts[i]
        this.data.push(this.formFB.group({
          costId: [_id],
          cost: new UntypedFormControl(name, Validators.required),
          noOfUnits: new UntypedFormControl(noOfUnits, Validators.required),
          pricePerUnit: new UntypedFormControl(pricePerUnit, Validators.required),
          saved: true
        }));
    }
  });
  }

  get data(): UntypedFormArray {
    return this.addCostForm.get("data") as UntypedFormArray
  }

  updateStatus(i) {
    this.addCostForm.value.data[i].saved = false
  }

  newCost(){
    return this.formFB.group({
      costId: null,
      cost: ['', Validators.required],
      noOfUnits: [1, Validators.required],
      pricePerUnit: [0, Validators.required],
      saved: [false]
    })
  }

  addNewCost(){
    this.data.push(this.newCost())
  }

  openDelete(element) {
    this.removeAllPopup();
    let elem = element.parentElement;
    if (elem.classList.contains("active")) {
      elem.classList.remove("active");
    } else {
      elem.classList.add("active");
    }
  }

  cancelDelete(element) {
    let elem = element.parentElement.parentElement.parentElement;
    elem.classList.remove("active");
  }

  removeAllPopup() {
    let elements = this._elemRef.nativeElement.querySelectorAll('.btn-delete');
    for (let index = 0; index < elements.length; index++) {
      elements[index].classList.remove("active");
    }
  }

  removeCost(i){
    this._api.request('archiveSingleProjectCost','',`${this.projectId}/cost-management/othercosts/${this.extraCosts[i]['_id']}/archive`).subscribe((response)=>{
      if(response){
        this._toastr.success('Verwijderd','Success');
        this.data.removeAt(i);
      }(error)=>{
        this._toastr.error(error.message,'Error');
      }
    })
  }


  saveExtraCosts(){
    let payLoad = [];
    this.addCostForm.controls['data']['controls'].forEach((element)=>{
      payLoad.push(
        {
          name: element['controls']['cost'].value,
          pricePerUnit:element['controls']['pricePerUnit'].value !== null ? element['controls']['pricePerUnit'].value : 0 ,
          noOfUnits: element['controls']['noOfUnits'].value,
      });
    });
    const otherCostsPayLoad = {
      otherCosts: payLoad
    }
    this._api.request('updateOtherCosts', otherCostsPayLoad,`${this.projectId}/cost-management/otherCosts`).subscribe((result) => {
      if(result){
        this._toastr.success('Succesvol','Success');
      }(error)=>{
        this._toastr.error(error.message,'Error');
      }
    });
    this.saveExtraCostEventStatus.emit(false);
    payLoad = [];
  }

}
